import { AccountDto } from '../routes/account/store/Account';
import { AuthSessionDto } from '../routes/login/store/AuthSession';
import { UserDto } from '../routes/users/store/User';
import { QueryParams } from '../store/utils/query/Query';
import { QueryResponseDto } from '../store/utils/query/QueryResponse';
import ApiHttpClient from './ApiHttpClient';

export default class Users {
  constructor(private readonly client: ApiHttpClient) {}

  async createUser(user: UserDto): Promise<UserDto> {
    return this.client.post(`v1/admin/users`, user);
  }

  async deleteUser(userId: string) {
    return this.client.delete(`v1/admin/users/${userId}`);
  }

  async findUsers(
    query: QueryParams<UserDto>,
  ): Promise<QueryResponseDto<UserDto>> {
    return this.client.get(`v1/admin/users`, { query });
  }

  async generateAuthInfo(userId: string): Promise<AccountDto & AuthSessionDto> {
    return this.client.post(`v1/admin/users/${userId}/generateAuthInfo`);
  }

  async getUser(userId: string): Promise<UserDto> {
    return this.client.get(`v1/admin/users/${userId}`);
  }

  async updateUser(user: UserDto) {
    return this.client.put(`v1/admin/users/${user.id}`, user);
  }
}
